var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectsvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.333px",
    height: "119.082px",
    viewBox: "6.001 16.085 163.333 119.082",
    enableBackground: "new 6.001 16.085 163.333 119.082",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 168.55,
    y1: 17.098,
    x2: 161.207,
    y2: 83.186
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "109.805,134.588 109.805,83.186  161.207,83.186 161.207,134.588  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 7,
    y1: 17.098,
    x2: 14.343,
    y2: 83.186
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "65.746,134.588 65.746,83.186  14.343,83.186 14.343,134.588  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 117.148,
    y1: 53.813,
    x2: 58.401,
    y2: 53.813
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 87.775,
    y1: 53.813,
    x2: 87.775,
    y2: 134.588
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 95.118,
    y1: 134.588,
    x2: 80.432,
    y2: 134.588
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectsvg2);
export default __webpack_public_path__ + "static/media/perfectsvg2.4d55a5eac9e924ae4d4258102a20ce74.svg";
export { ForwardRef as ReactComponent };